import { financialIncentivesData } from "../../config/homePageUtils";
import Section from "./Section";

const FinancialIncentives = ({ language = false }) => {
  return (
    <Section
      id="financial-incentives"
      title="Financial Incentives"
      spaceY4Needed={false}
    >
      <table className="table-auto w-full border border-gray-300">
        <thead>
          <tr>
            <th className="border px-4 py-2 text-left">Section</th>
            <th className="border px-4 py-2 text-left">Details</th>
          </tr>
        </thead>

        <tbody>
          {financialIncentivesData.map((item, i) => (
            <>
              {/* First row: section + first detail */}
              <tr key={`${i}-0`}>
                <td
                  className="border border-gray-300 px-4 py-2 font-medium"
                  rowSpan={item.details.length}
                >
                  {language ? item.section.hi : item.section.en}
                </td>

                <td className="border border-gray-300 px-4 py-2">
                  {language ? item.details[0].hi : item.details[0].en}
                </td>
              </tr>

              {/* Remaining rows */}
              {item.details.slice(1).map((detail, j) => (
                <tr key={`${i}-${j + 1}`}>
                  <td className="border border-gray-300 px-4 py-2">
                    {language ? detail.hi : detail.en}
                  </td>
                </tr>
              ))}
            </>
          ))}
        </tbody>
      </table>
    </Section>
  );
};

export default FinancialIncentives;
